<button mat-stroked-button color="primary" (click)="openDialog()">
  <mat-icon svgIcon="upload" />
  {{ 'DOCUMENTS.file-manager.actions.upload' | translate }}
</button>
